import { MemberActivityData } from './MemberActivityData';

export default MemberActivityData;
